import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { SpinnerService } from '../../shared-components/spinner/spinner.service';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-broadcastings-programming-grid-card',
  templateUrl: './broadcastings-broadcastings-programming-grid-card.component.html',
  styleUrls: ['./broadcastings-broadcastings-programming-grid-card.component.scss']
})
export class BroadcastingsBroadcastingsProgrammingGridCardComponent implements OnInit, OnDestroy {

  title;
  headers;
  data;
  dateType;
  centers;
  loading;
  basicDataForm = new FormGroup({
    selectedCenter: new FormControl(null),
    type: new FormControl(null),
    time: new FormControl(null)
  });
  types = [{
    id: 'BROADCASTING',
    value: 'broadcastings-page.per broadcasting'
  },
  {
    id: 'DEVICE',
    value: 'broadcastings-page.per device'
  }];
  times = [{
    id: 'DAY',
    value: 'broadcastings-page.day'
  },
  {
    id: 'WEEK',
    value: 'broadcastings-page.week'
  },
  {
    id: 'MONTH',
    value: 'broadcastings-page.month'
  }];
  getBroadcastingGridDeviceViewSubscription: Subscription;
  getBroadcastingGridBroadcastingViewSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
            private snackbarService: SnackBarService,
            private spinnerService: SpinnerService,
            private broadcastingsService: BroadcastingsService) {
    this.centers = this.userStorageService.getCenterList();
  }

  ngOnInit() {
    this.valueChanges();
  }

  public getBroadcastingGridDeviceView() {
    this.spinnerService.show('broadcastings-grid-spinner');
    this.loading = true;
    this.getBroadcastingGridDeviceViewSubscription = this.broadcastingsService.getBroadcastingGridDeviceView(this.basicDataForm.get('time').value.id, [this.basicDataForm.get('selectedCenter').value.internalId]).pipe(
      tap(o => this.title = o['title']),
      tap(o => this.headers = o['headers']),
      tap(o => this.data = o['data'].sort((a, b) => a['active'] === b['active'] ? 0 : a['active'] ? -1 : 1 )),
      tap(o => this.dateType = o['dateType']),
      tap(o => this.spinnerService.hide('broadcastings-grid-spinner')),
      tap(o => this.loading = false),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getBroadcastingGridBroadcastingView() {
    this.loading = true;
    this.spinnerService.show('broadcastings-grid-spinner');
    this.getBroadcastingGridBroadcastingViewSubscription = this.broadcastingsService.getBroadcastingGridBroadcastingView(this.basicDataForm.get('time').value.id, [this.basicDataForm.get('selectedCenter').value.internalId]).pipe(
      tap(o => this.title = o['title']),
      tap(o => this.headers = o['headers']),
      tap(o => this.data = o['data'].sort((a, b) => a['active'] === b['active'] ? 0 : a['active'] ? -1 : 1 )),
      tap(o => this.dateType = o['dateType']),
      tap(o => this.spinnerService.hide('broadcastings-grid-spinner')),
      tap(o => this.loading = false),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public valueChanges() {
    this.basicDataForm.valueChanges.pipe(
      tap(o => {
        if (this.basicDataForm.get('selectedCenter').value &&
            this.basicDataForm.get('selectedCenter').value.internalId &&
            this.basicDataForm.get('time').value &&
            this.basicDataForm.get('time').value.id &&
            this.basicDataForm.get('type').value &&
            this.basicDataForm.get('type').value.id) {
              switch (this.basicDataForm.get('type').value.id) {
                case 'DEVICE':
                  this.getBroadcastingGridDeviceView();
                  break;
                case 'BROADCASTING':
                  this.getBroadcastingGridBroadcastingView();
                  break;
              }
            }
      })
    ).subscribe();
    this.basicDataForm.patchValue({
      selectedCenter: this.centers[0],
      type: this.types[0],
      time: this.times[0]
    });
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.id === op2.id;
    }
  }

  ngOnDestroy() {
    if (this.getBroadcastingGridDeviceViewSubscription) { this.getBroadcastingGridDeviceViewSubscription.unsubscribe(); }
  }
}
